import {Component, Input} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {ListViewItem} from '@domain/common/list-view/list-view-item';
import {TranslateService} from '@ngx-translate/core';
import {Compte} from '@domain/contrat/compte';

/**
 * Composant d'affichage d'un item compte dans une liste
 *
 * @author Yannick Gauthier
 * @date 18/08/2025
 */
@Component({
    host: {'data-test-id': 'contrat-comptes-item'},
    selector: 'contrat-comptes-item',
    templateUrl: './contrat-comptes-item.component.html'
})
export class ContratComptesItemComponent extends ListViewItem<Compte> {
    /** Données du compte */
    @Input() data: Compte;

    /** Affichage/masquage de l'élément */
    @Input() toggleItem: (data: Compte) => void;

    /**
     * Constructeur
     *
     * @param router Service de routage
     * @param activatedRoute Route activée
     * @param translateService Service de traduction
     */
    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private translateService: TranslateService
    ) {
        super();
    }

    /**
     * Méthode appelée lors du clic sur l'item
     */
    onItemClick(): void {
        const idContrat = this.activatedRoute.parent.snapshot.params.idContrat;
        const idFournisseur = this.activatedRoute.parent.snapshot.queryParams.idFournisseur;
        this.router.navigate(['Admin/Frais/Factures/Contrat', idContrat, 'Compte', this.data.idCarte],
            { queryParams: { idFournisseur: idFournisseur } });
    }

    /**
     * Retourne le statut du compte sous forme de texte
     */
    getStatutCompte(): string {
        if (this.data.actif) {
            return this.translateService.instant('global.oui');
        } else {
            return this.translateService.instant('global.non');
        }
    }
}
